import config from "@/config";
import http from "@/utils/request";

export default {
	user: {
		getUserListQuery: {
			url: `${config.API_URL}/admin/user/getUserListQuery`,
			name: "获取用户列表查询",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
	},
};
